module.exports = __webpack_public_path__ + "static/desktop/img/swipe-calendar-v.5b554faf.jpg";